export const applicationCreateDtoCategoryEnum = {
    1: 1,
    2: 2,
    3: 3,
    4: 4,
    5: 5,
    6: 6,
    8: 8,
} as const;

export type ApplicationCreateDtoCategoryEnum = (typeof applicationCreateDtoCategoryEnum)[keyof typeof applicationCreateDtoCategoryEnum]

export type ApplicationCreateDto = {
    /**
     * @type string, binary
     */
    file: Blob
    /**
     * @type number
     */
    organization_id: number
    /**
     * @minLength 1
     * @maxLength 255
     * @type string
     */
    last_name: string
    /**
     * @minLength 1
     * @maxLength 255
     * @type string
     */
    first_name: string
    /**
     * @minLength 1
     * @maxLength 255
     * @type string
     */
    patronymic: string | null
    /**
     * @type string
     */
    iin: string
    /**
     * @minLength 1
     * @maxLength 50
     * @type string
     */
    application_number: string
    /**
     * @type string, date-time
     */
    date: string
    /**
     * @type number
     */
    category: ApplicationCreateDtoCategoryEnum
}

export type ScheduleDayParams = {
    organization_id: number | null | undefined,
    date: string | null | undefined,
}

export type DrivingScheduleDto = {
    /**
     * @type number
     */
    staff_id: number
    /**
     * @type string, date-time
     */
    date: string
    /**
     * @type string
     */
    start_time: string
    /**
     * @type string
     */
    end_time: string
    /**
     * @type array
     */
    excepts: string[]
    /**
     * @type string, date-time
     */
    created_at: string
    /**
     * @type string, date-time
     */
    updated_at: string
    /**
     * @type number
     */
    max_parallels: number
}

export type MonthScheduleDto = {
    schedule: Record<string, DrivingScheduleDto>
}

export type DrivingServiceDto = {
    /**
     * @type number
     */
    id: number
    /**
     * @type number
     */
    staff_id: number
    /**
     * @type number
     */
    duration_minutes: number
    /**
     * @type string
     */
    title: string
    /**
     * @type string
     */
    description: string | null
    /**
     * @type string, date-time
     */
    created_at: string
    /**
     * @type string, date-time
     */
    updated_at: string
}

export type OrganizationPreviewDto = {
    /**
     * @type number
     */
    id: number
    /**
     * @type string
     */
    title: string
    /**
     * @type string
     */
    avatar: string | null
    /**
     * @type string
     */
    address: string | null
}

export type OrganizationDto = {
    /**
     * @type number
     */
    id: number
    /**
     * @type string
     */
    title: string
    /**
     * @type string
     */
    avatar: string | null
    /**
     * @type string
     */
    address: string | null
    sector: SectorPreviewDto | null
    /**
     * @type string, date-time
     */
    created_at: string
    /**
     * @type string
     */
    email: string | null
    /**
     * @type string
     */
    phone: string | null
}

export type SectorPreviewDto = {
    /**
     * @type number
     */
    id: number
    /**
     * @type string
     */
    title: string
    /**
     * @type number
     */
    region_id: number
}

export const organizationFilterSortEnum = {
    'id.asc': 'id.asc',
    'id.desc': 'id.desc',
    'created_at.asc': 'created_at.asc',
    'created_at.desc': 'created_at.desc',
} as const;

export type OrganizationFilterSortEnum = (typeof organizationFilterSortEnum)[keyof typeof organizationFilterSortEnum]

export type OrganizationFilterSort = OrganizationFilterSortEnum

export const organizationsFilterRoleEnum = {
    _all: '_all',
    _my: '_my',
} as const;

export type OrganizationsFilterRoleEnum = (typeof organizationsFilterRoleEnum)[keyof typeof organizationsFilterRoleEnum]

export type OrganizationsFilterRole = OrganizationsFilterRoleEnum

export type SearchOrganizationsQueryParams = {
    /**
     * @type array | undefined
     */
    sort?: OrganizationFilterSort[]
    /**
     * @type string | undefined
     */
    role?: OrganizationsFilterRole
    /**
     * @type string
     */
    q?: string | null
    /**
     * @minLength 1
     * @maxLength 1000
     * @type number
     */
    count: number
    /**
     * @minLength 0
     * @type number
     */
    offset: number
    /**
     * @type number | undefined
     */
    sector_id?: number
}

export type OrganizationSearchDto = {
    /**
     * @type number
     */
    count: number
    /**
     * @type number
     */
    sum: number
    /**
     * @type number
     */
    offset: number
    /**
     * @type array
     */
    items: OrganizationSearchPreviewDto[]
}

export type OrganizationSearchPreviewDto = {
    /**
     * @type number
     */
    id: number
    /**
     * @type string
     */
    title: string
    /**
     * @type string
     */
    avatar: string | null
    /**
     * @type string
     */
    address: string | null
    sector: SectorPreviewDto | null
    /**
     * @type string, date-time
     */
    created_at: string
}

export type DrivingAvailableTimesDayDto = {
    /**
     * @type array
     */
    available_times: string[]
}

export type DrivingScheduleMonthDto = {
    schedule: Record<string, {
        start_time: string,
        end_time: string,
        excepts: string[]
    } | null>
}